import Header from './components/Header';
import Hero from './components/Hero';
import FaqSection from './components/FaqSection';
import MediaSection from './components/MediaSection';
import ContactSection from './components/ContactSection';
import CarouselSection from './components/CarouselSection';
import AboutSection from './components/AboutSection';
import RankingSection from './components/RankingSection';
import FeaturesSection from './components/FeaturesSection';
import AppSection from './components/AppSection';
import TopicsSection from './components/TopicsSection';
import CardsSection from './components/CardsSection';
import UpdatesSection from './components/UpdatesSection';
import IndexSection from './components/IndexSection';
import CommentsSection from './components/CommentsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <FaqSection />
        <MediaSection />
        <ContactSection />
        <CarouselSection />
        <AboutSection />
        <RankingSection />
        <FeaturesSection />
        <AppSection />
        <TopicsSection />
        <CardsSection />
        <UpdatesSection />
        <IndexSection />
        <CommentsSection />
      </main>
      <Footer />
    </>
  );
}